(function () {
  function initDotsForSliderComponent(sliderComponent) {
    // Nur Mobile (gleich wie dein Slider-Setup)
    if (window.matchMedia('(min-width: 990px)').matches) return;

    const track = sliderComponent.querySelector('ul.slider');
    if (!track) return;

    // Nur Produkt-Slider (Featured Collection etc.)
    const isProductGrid = track.classList.contains('product-grid');
    if (!isProductGrid) return;

    const slides = Array.from(track.querySelectorAll('.slider__slide'));
    if (slides.length <= 1) return;

    // Dots-Container erstellen (falls nicht existiert)
    let dots = sliderComponent.querySelector('.mrd-slider-dots');
    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'mrd-slider-dots';
      // möglichst unter den vorhandenen slider-buttons platzieren
      const buttons = sliderComponent.querySelector('.slider-buttons');
      if (buttons && buttons.parentNode) {
        buttons.parentNode.insertBefore(dots, buttons.nextSibling);
      } else {
        sliderComponent.appendChild(dots);
      }
    }

    // Dots neu aufbauen
    dots.innerHTML = '';
    const dotButtons = slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Slide ${i + 1}`);
      b.addEventListener('click', () => {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dots.appendChild(b);
      return b;
    });

    function setActive(index) {
      dotButtons.forEach((btn, i) => btn.classList.toggle('is-active', i === index));
    }

    // Robust: aktiven Slide via IntersectionObserver bestimmen
    const observer = new IntersectionObserver(
      (entries) => {
        // Nimm den Slide mit der höchsten Sichtbarkeit
        let best = null;
        for (const e of entries) {
          if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
        }
        if (!best) return;
        const idx = slides.indexOf(best.target);
        if (idx >= 0) setActive(idx);
      },
      {
        root: track,
        threshold: [0.55, 0.6, 0.65, 0.7, 0.75],
      }
    );

    slides.forEach((s) => observer.observe(s));

    // Initial
    setActive(0);
  }

  function init() {
    document.querySelectorAll('slider-component').forEach(initDotsForSliderComponent);
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', () => {
    // bei Resize neu initialisieren (z. B. Orientation Change)
    init();
  });
})();